// extracted by mini-css-extract-plugin
module.exports = {"header":"tabs__styles__header--127FtLnK","heading":"tabs__styles__heading--3LPNXerP","isActive":"tabs__styles__isActive--2Se_2fZM","isHidden":"tabs__styles__isHidden--3FLfRfn5"};